import TemplateDetailController from './template.detail.controller';

export default {
    controller: TemplateDetailController,
    template: require('./template.detail.html')
};
